import React from 'react';
import { Icon } from '../../Icons';
import { Ripple } from '../../Ripple';

interface Props {
  sharedLink: string;
  icon: string;
  typeShared: string;
  onClick: any;
}
export const FacebookShared = ({ icon, typeShared, onClick }: Props) => {
  return (
    <Ripple>
      <li className="pt16 pb16 b--alto bb pointer hover-bg-wild-sand">
        <a
          className="flex items-center f14 fw4 abbey no-underline"
          target="_blank"
          title={typeShared}
          onClick={onClick}
        >
          <Icon name={icon} className="mr4" height={24} width={24} />
          {typeShared}
        </a>
      </li>
    </Ripple>
  );
};
